import React from "react";
const headingTagMap = {
    "h1-v2dot6": "h1",
    "h2-v2dot6": "h2",
    "h3-v2dot6": "h3",
    "h4-v2dot6": "h4",
    "h5-v2dot6": "h5",
    "h6-v2dot6": "h6",
    "h4-semi-bold": "h4",
};
const getTag = (design) => headingTagMap[design ?? "h2-v2dot6"] ?? "h2";
export const HeadingFactoryWithHTMLContent = ({ headingContent, headingDesign, style, className, }) => {
    const HeadingTag = getTag(headingDesign);
    if (headingContent) {
        return (React.createElement(HeadingTag, { dangerouslySetInnerHTML: { __html: headingContent }, className: `${className || ""} ${headingDesign}`, style: style }));
    }
    return React.createElement(React.Fragment, null);
};
